import { AssetType } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredEmail, requiredEnumArray, requiredString } from '@/utils/zodUtils';

export const CreateAgentSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      name: requiredString(t),
      email: requiredEmail(t),
      allowedAssetTypes: requiredEnumArray(AssetType, t),
    })
    .strict();

export type CreateAgentSchemaType = z.infer<ReturnType<typeof CreateAgentSchema>>;
